import { RiskLevel } from '@common/utils/calculateRiskScore';
import { Avatar } from '@mui/material';

const RISK_LEVEL_MAP = {
  high: '/static/RiskLevelImages/high_risk.svg',
  medium: '/static/RiskLevelImages/medium_risk.svg',
  low: '/static/RiskLevelImages/low_risk.svg',
};

const EMPTY_STATE_RISK_LEVEL = '/static/RiskLevelImages/empty_risk.svg';

export function RiskLevelImage({ riskLevel }: { riskLevel: string }) {
  const imgSrc = getRiskLevelSVGFromString(riskLevel);

  return <Avatar alt="Risk Level" variant="square" src={imgSrc} sx={{ width: '22px', height: '17px' }} />;
}

const getRiskLevelSVGFromString = (riskLevel: string) => {
  const level = riskLevel.toLowerCase();
  if (level in RISK_LEVEL_MAP) {
    return RISK_LEVEL_MAP[level as RiskLevel];
  }
  return EMPTY_STATE_RISK_LEVEL;
};
